import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';

export default function Footer() {
    
    return (
        <>
            <footer>
                <div className="footer_top_content">
                    <div className="container-lg">
                        <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="footer_start_content">
                                    <div className="logo">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row footer_row">
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="footer_start_content">
                                    <div className="footer_title">
                                        <p>Contact Details</p>
                                    </div>
                                    <ul className="icon_text">
                                        <li className="icon_text_inner">
                                            <div className="icon">
                                                <i className="fi fi-rr-marker"></i>
                                            </div>
                                            <div className="text">
                                                <p>11 Kung Chong Road Singapore 159147</p>
                                            </div>
                                        </li>
                                        <li className="icon_text_inner">
                                            <div className="icon">
                                                <i className="fi fi-rr-envelope"></i>
                                            </div>
                                            <div className="text">
                                                <a className="text-lowercase" href="mailto:loans@eurokars.com.sg">
                                                    loans@eurokars.com.sg
                                                </a>
                                            </div>
                                        </li>
                                        <li className="icon_text_inner">
                                            <div className="icon">
                                                <i className="fi fi-rr-phone-call"></i>
                                            </div>
                                            <div className="text">
                                                <a href="tel:+65 6363 3003">+65 6363 3003 </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="footer_link_content">
                                    <div className="footer_title">
                                        <p>Operating Hours</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li>
                                                    <p>Monday - Thursday: 8.30am - 6.00pm</p>
                                                </li>
                                                <li>
                                                    <p>Friday: 8.30am - 5.30pm</p>
                                                </li>
                                                <li>
                                                    <p>Weekends &amp; PH: Closed</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6">
                                <div className="footer_link_content footer_end_content">
                                    <div className="footer_title">
                                        <a href="https://www.eurokarsgroup.com/" target="_blank">Eurokars Group</a>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="text">
                                                <p>Eurokars Financial Services (EFS) is a registered business of Indo Universal Pte. Ltd. and an affiliate of the Eurokars Group. We provide seamless hire-purchase financing complemented by trusted motor insurance protection. As part of the Eurokars Group, we are dedicated to delivering premium automotive excellence through passion. Driving luxury experiences since 1985.</p>
                                                <a href="https://www.eurokarsgroup.com/" target="_blank">Click here to find out more.</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-6">
                                <div className="footer_link_content footer_end_content">
                                    <div className="footer_title">
                                        <p>Legal</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="footer_link">
                                                <ul>
                                                    <li>
                                                        <a href="https://www.eurokarsgroup.com/data-protection" target="_blank">Data Protection Policy</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_bottom_content">
                    <div className="container-lg">
                        <div className="row">
                            <div className="col-12">
                                <div className="text text-center">
                                    <p>We use cookies to ensure that we give you the best experience on our website. By using our website, you agree to our&nbsp;Privacy Policy&nbsp;&amp;&nbsp;Cookie Policy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}